import { render, staticRenderFns } from "./FooterViewingStats.vue?vue&type=template&id=bb6319da&"
import script from "./FooterViewingStats.vue?vue&type=script&lang=js&"
export * from "./FooterViewingStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports